import { useCallback, useEffect, useState } from 'react'
import { buildProductPathFromIdentity } from '../../routing'
import type { CatalogProduct } from '../../types'

export const useProductShareFeedback = ({
  productData,
  toLocalizedPath,
}: {
  productData: CatalogProduct | null
  toLocalizedPath: (path: string) => string
}) => {
  const [shareFeedback, setShareFeedback] = useState('')

  useEffect(() => {
    setShareFeedback('')
  }, [productData?._id])

  const handleShareProduct = useCallback(async () => {
    if (!productData || typeof window === 'undefined') return
    const productPath = buildProductPathFromIdentity({
      publicCode: productData.publicCode,
      slug: productData.slug,
    })
    const url = `${window.location.origin}${toLocalizedPath(productPath)}`

    try {
      if (typeof navigator !== 'undefined' && typeof navigator.share === 'function') {
        await navigator.share({ title: productData.name, url })
        setShareFeedback('Link condiviso con successo.')
        return
      }
      if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(url)
        setShareFeedback('Link copiato negli appunti.')
        return
      }
      setShareFeedback('Condivisione non supportata da questo browser.')
    } catch (error) {
      if (error instanceof DOMException && error.name === 'AbortError') return
      setShareFeedback('Impossibile condividere il prodotto in questo momento.')
    }
  }, [productData, toLocalizedPath])

  return { shareFeedback, handleShareProduct }
}
